import {observer} from 'mobx-react-lite'
import React from 'react'
import tw from 'tailwind-styled-components'
import {Lang} from 'yougile-lang'
import {LinkButtonNew} from '@components/common/base/buttons'
import {WithPerfectScrollbar} from '@components/common/with-scrollbar/with-scrollbar'
import {
  TwPage,
  TwTitle,
  TwTitleText
} from '@components/sticker/my-stickers/containers'
import {useBoard, useBoolean} from '@containers/hooks'
import {Sticker} from '@extensions/sticker/sticker'
import {useMyStickersStore} from '../my-stickers-store'
import {BoardStickersItem} from './board-stickers-item'

const TwBoardStickers = tw(WithPerfectScrollbar)`
  flex-1
  py-8
  pl-8
  -ml-8
  pr-16
  -mr-16
`

const TwBoardStickersList = tw.div`
  grid
  grid-cols-2
  gap-8
`

export const BoardStickers = observer(() => {
  const [state, store] = useMyStickersStore()
  const scrollTop = useBoolean(true)
  const board = useBoard()

  return (
    <TwPage>
      <TwTitle>
        <TwTitleText>{Lang.msg.myStickers.boardStickersTitle}</TwTitleText>
        <LinkButtonNew
          icon="IconPlus"
          title={Lang.msg.myStickers.createSticker}
          onClick={() => store.setCurrentTab('new')}
          className="ml-auto"
        />
        <LinkButtonNew
          icon="IconCustomExistingPlus"
          title={Lang.msg.myStickers.otherBoardsStickers}
          onClick={() => store.setCurrentTab('library')}
        />
      </TwTitle>
      <TwBoardStickers onScrollY={x => scrollTop.setValue(x.scrollTop === 0)}>
        <TwBoardStickersList>
          {state.boardStickers.map(sticker => (
            <BoardStickersItem
              key={sticker.id}
              sticker={sticker}
              active={Sticker.isInBoard(board, sticker)}
              board={board}
            />
          ))}
        </TwBoardStickersList>
      </TwBoardStickers>
    </TwPage>
  )
})
